import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/profile.jpg'


const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "grid md:grid-cols-2 gap-8 items-center" }
const _hoisted_5 = { class: "space-y-4 text-center md:text-left" }
const _hoisted_6 = { class: "text-gray-600 leading-relaxed" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-4 mt-6" }
const _hoisted_8 = { class: "bg-blue-50 p-4 rounded-lg text-center" }
const _hoisted_9 = { class: "font-semibold text-blue-800" }
const _hoisted_10 = { class: "text-sm text-blue-600 whitespace-pre-line" }
const _hoisted_11 = { class: "bg-purple-50 p-4 rounded-lg text-center" }
const _hoisted_12 = { class: "font-semibold text-purple-800" }
const _hoisted_13 = { class: "text-sm text-purple-600 whitespace-pre-line" }
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "w-64 h-64 bg-gradient-to-br from-blue-400 to-purple-600 rounded-full p-1 hover-lift" }
const _hoisted_17 = { class: "w-full h-full bg-white rounded-full overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('profile.title')), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-800" }, "sea-turt1e", -1)),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('profile.detailedDescription')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t('profile.specialization')), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('profile.specializationDetail')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('profile.otherSkills')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('profile.otherSkillDetail')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "プロフィール画像",
                class: "w-full h-full object-cover",
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
              }, null, 32)
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute -bottom-4 -right-4 bg-yellow-400 rounded-full p-3 hover-lift" }, [
            _createElementVNode("span", { class: "text-2xl" }, "🏀")
          ], -1))
        ])
      ])
    ])
  ]))
}